export const sharedRouteNames = {
  CREATE_CAMPAIGN: { name: 'CREATE_CAMPAIGN' },
  ADVERTISER_EDIT_CAMPAIGN: { name: 'ADVERTISER_EDIT_CAMPAIGN' },
  CAMPAIGN_SUBMIT: { name: 'CAMPAIGN_SUBMIT' },
  DESIGN_UPLOAD: { name: 'DESIGN_UPLOAD' },
  UPLOAD_SUCCESS: { name: 'UPLOAD_SUCCESS' },
  PAGE_NOT_FOUND: { name: 'PAGE_NOT_FOUND' },
};
